import { useTranslation } from 'react-i18next';
import { Button, ButtonsWrapper, Form } from '@thinknet-gmbh/platform-common-ui';

import { getStepsFormFieldsData } from './questionnaire-form.helpers';

import { useGetAllHealthInsurance } from 'src/hooks/health-insurance/get-all-health-insurance.hook';

import FormItemFieldComponent from './components/form-item-field/form-item-field.component';
import { QuestionnairePageFormWrapper } from '../questionnaire-page-form-wrapper';

import { IQuestionnaireFormProps } from 'src/pages/auth/sub-pages/questionnaire/questionnaire.interfaces';

import { FormFieldContainer } from './questionnaire-form.styles';

const QuestionnaireForm = ({
  initialValues,
  onFinish,
  fields,
  isFirstStep,
  isLastStep,
  handleStepBack,
  formType,
  questionnaireSetting,
  isFinishStep,
}: IQuestionnaireFormProps) => {
  const { t, i18n } = useTranslation('employee');
  const [form] = Form.useForm();

  const handleBack = () => {
    const signature = form.getFieldValue('signatureId');

    if (signature) {
      form.setFieldsValue({
        signatureId: null,
      });
    }

    handleStepBack();
  };

  const { healthInsurance } = useGetAllHealthInsurance();

  const formItems =
    getStepsFormFieldsData({ formType, t, i18n, questionnaireSetting, healthInsurance }) || {};

  return (
    <QuestionnairePageFormWrapper
      title={t(`employee:questionnaire.labels.${formType}`)}
      subtitle={t(`employee:questionnaire.labels.${formType}Subtitle`)}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        initialValues={initialValues}
      >
        <FormFieldContainer isFinishStep={isFinishStep}>
          {fields &&
            fields?.map(field => {
              const fieldProps = formItems[field];
              return fieldProps ? (
                <FormItemFieldComponent key={field} form={form} {...fieldProps} />
              ) : null;
            })}
        </FormFieldContainer>
        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t(`common:buttons.${isLastStep ? 'finishAndSend' : 'next'}`)}
          </Button>
          {!isFirstStep && <Button onClick={handleBack}>{t('common:buttons.back')}</Button>}
        </ButtonsWrapper>
      </Form>
    </QuestionnairePageFormWrapper>
  );
};

export default QuestionnaireForm;
